/**
 * Measure the site navbar's actual height and publish it as a CSS
 * variable so every modal / overlay can clear it correctly. The
 * navbar is a fixed element (z-index ~99999); we walk the candidate
 * selectors, look for the first that's `position: fixed` and
 * touching the top edge, and use its height. Falls back to 80px
 * desktop / 56px mobile guesses.
 *
 * Vars written:
 *   --site-nav-height   — used by Studio2 + Gallery2
 *   --fs2-nav-h         — used by FaceSwap2 (kept for back-compat)
 */
const SELECTORS = 'nav, header, .navbar, [class*="navbar"]';

function _measure() {
  let h = window.innerWidth < 768 ? 56 : 80;
  try {
    const candidates = document.querySelectorAll(SELECTORS);
    for (const el of candidates) {
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      const r = el.getBoundingClientRect();
      if (r.top <= 1 && r.height > 10 && r.height < 200) {
        h = Math.ceil(r.height);
        break;
      }
    }
  } catch (_) { /* keep fallback */ }
  document.documentElement.style.setProperty('--site-nav-height', `${h}px`);
  document.documentElement.style.setProperty('--fs2-nav-h', `${h}px`);
  return h;
}

/**
 * Attach the measure to the lifecycle of a Vue component instance.
 * Call from `mounted()`, store the returned cleanup on `this`, and
 * call it back in `beforeUnmount()`.
 */
export function attachNavHeightWatcher() {
  _measure();
  const handler = () => _measure();
  window.addEventListener('resize', handler);
  window.addEventListener('orientationchange', handler);
  return () => {
    window.removeEventListener('resize', handler);
    window.removeEventListener('orientationchange', handler);
  };
}

export const measureNav = _measure;
